import CryptoJS from 'crypto-js'
import { envConfig } from '@/configs/env'

/** Web 端 X-Sign：md5(deviceId + timestamp + SECRET_KEY)。正式环境请配置 VITE_X_SIGN_SECRET */
const X_SIGN_SECRET_TEST = 'K9GjD1JuuDJh9pBqfhcDk6ot6Q'
const X_SIGN_SECRET_PRODUCTION = '54J21SWAOVqSb6XvyJQKVICdR0OJc5q'

function resolveSecret() {
  const fromEnv = import.meta.env.VITE_X_SIGN_SECRET
  if (fromEnv != null && fromEnv !== '') {
    return fromEnv
  }
  if (envConfig.isProduction) {
    return X_SIGN_SECRET_PRODUCTION
  }
  return X_SIGN_SECRET_TEST
}

/** timestamp 必须与请求体里的 timestamp 一致（axios POST / SSE body） */
export function getWebXSignHeader(timestamp) {
  const deviceId = localStorage.getItem('device_id') ?? ''
  const signPlain = `${deviceId}${timestamp}${resolveSecret()}`
  return CryptoJS.MD5(signPlain).toString()
}
